<template>
  <div class="body-container text-center">
    <div class="signIn-container border-container align-items-center d-inline-grid">
      <div>
        <AuthVerifyEmail v-if="activeScreen == 'verifyEmail'" :lang="lang" :eventType="'username'" :buttonTitle="widget.translate('label_retrieve_username_button', 'Retrieve Username')" :navTitle="this.widget.translate('label_forgot_username_title', 'Forgot Username')" @updateActiveScreen="updateActiveScreen"></AuthVerifyEmail>
        <AuthOtp v-if="activeScreen == 'verifyOtp'" :lang="lang" :phoneFlag="selectedPhone" :eventType="'username'" :email="createUsername.email" :mobile="mobile && mobile.number && mobile.number.significant" :studyType="studyType" :title="widget.translate('pweb_title_verify_identity', 'Verify Identity')" @updateActiveScreen="updateActiveScreen" @onResendVerificationCode="resendOtp"></AuthOtp>
        <Studies v-if="activeScreen == 'selectStudy'" :lang="lang" :email="createUsername.email" :phoneFlag="selectedPhone" :mobile="mobile" :eventType="'username'" :studyType="studyType" @updateActiveScreen="updateActiveScreen"></Studies>
        <Reset v-if="activeScreen == 'resetUsername' && pwebCognitoAuthentication" :lang="lang" :phoneFlag="selectedPhone" :mobile="mobile" :data="createUsername" :eventType="'username'" @updateActiveScreen="updateActiveScreen"></Reset>
      </div>
    </div>
    <Modal :show="showCancelModal" :title="widget.translate('ARE_YOU_SURE_TEXT', 'Are you sure?')" :helpText="widget.translate('pweb_help_text_cancel_forgot_username', 'You would like to cancel the Forgot Username process.')" :cancelButton="widget.translate('CANCEL_BUTTON_TITLE', 'Cancel')" :okButton="widget.translate('label_ok', 'OK')" @modalCallback="modalCallback"></Modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AuthOtp from "@/components/participant-portal/auth/otp";
import AuthVerifyEmail from "@/components/participant-portal/auth/verify-email";
import Studies from "@/components/participant-portal/auth/studies";
import Reset from "@/components/participant-portal/auth/forgot/reset";
import Modal from "@/components/participant-portal/common/modal";
import { Widget, ParticipantPortal } from "@/components/services/participant-service";

export default {
  name: "auth-forgot-username",
  components: { AuthOtp, AuthVerifyEmail, Studies, Reset, Modal },
  props: ["isOnCancelClick", "isOnBackClick", "forgotPassword", "globalElement", "isStudySelected"],
  data() {
    return {
      loading: false,
      isLoginSuccess: false,
      widget: new Widget(),
      selectedPhone: null,
      portal: new ParticipantPortal(),
      studyType: "",
      screens: [
        { name: "verifyEmail", isActive: true },
        { name: "verifyOtp", isActive: false },
        { name: "selectStudy", isActive: false },
        { name: "resetUsername", isActive: false }
      ],
      activeScreen: "verifyEmail",

      createUsername: {
        email: "",
        otp: "",
        username: "",
        password: "",
        studyId: null
      },
      pageTitle: null,
      showCancelModal: false,
      legacyForgotMessage: false,
      mobile: ""
    };
  },
  mounted() {
    this.pageTitle = this.widget.translate("label_forgot_username_title", "Forgot Username");
    this.$emit("setHeaderOptions", {
      showBlankHeader: true,
      title: this.pageTitle,
      backRouterLink: "participants-portal-auth-login"
    });
    this.$emit("setHeaderOptions", {
      showBlankHeader: true,
      title: this.pageTitle,
      eventHandler: "onVerifyMethodBackBtnClicked",
      backRouterLink: "participants-portal-auth-login"
    });

    if (this.pwebCognitoAuthentication == false) {
      this.$router.push({ name: "participants-portal-auth-login" });
    }
  },
  watch: {
    isOnBackClick(val) {
      if (val) {
        const activeIndex = this.screens.findIndex(e => e.isActive == true);
        if (activeIndex > 0 && activeIndex !== -1) {
          const newScreen = this.screens[activeIndex - 1];
          this.activeScreen = newScreen.name;
          this.screens = this.screens.map(e => {
            e.isActive = e.name == newScreen.name;
            return e;
          });
        }
      }
    },
    isOnCancelClick() {
      this.showCancelModal = !this.showCancelModal;
    }
  },
  computed: {
    ...mapGetters(["participant", "token", "pwebCognitoAuthentication"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    }
  },
  methods: {
    modalCallback() {
      this.$router.push({ name: "participants-portal-auth-login" });
    },
    updateActiveScreen(keyOld) {
      let key = keyOld;
      if (key.verificationPhone === "phone") {
        this.selectedPhone = "phone";
        this.mobile = key.mobile;
      }
      if (key.flagKey == "singleStudy") {
        this.studyType = key.flagKey;
        key.flagKey = "createUsername";
      }
      if (typeof key === "object") {
        if (Object.keys(key).includes("flagChild")) {
          this[key.flagKey][key.flagChild] = key.flagValue;
        } else {
          this[key.flagKey] = key.flagValue;
        }
        key = key.key;
      }

      if (key !== "verifyEmail") {
        this.$emit("setHeaderOptions", {
          showBlankHeader: true,
          title: this.pageTitle
        });
      }

      this.screens = this.screens.map(e => {
        e.isActive = false;
        return e;
      });
      const newScreen = this.screens.find(e => e.name == key);
      if (newScreen) {
        this.activeScreen = newScreen.name;
        this.screens = this.screens.map(e => {
          e.isActive = e.name == key;
          return e;
        });
      }
    },
    resendOtp() {
      const postCognitoData = {
        mobile: this.mobile.number.significant,
        countryCode: "+" + this.mobile.country.dialCode,
        languageId: this.portal.getLanguage(),
        deviceType: "web",
        studyId: this.portal.getStudy() ? this.portal.getStudy() : null,
        otpType: "CREATE_USERNAME"
      };
      this.$api
        .resendUsernameOtp(postCognitoData)
        .then(() => {
          this.$root.$emit("onOtpResent");
          this.$toastr.success(this.widget.translate("label_verification_code_resent", "Verification code has been resent."));
        })
        .catch(err => {
          const message = this.widget.translate(err.message, "Problem in resend code.");
          this.$toastr.error(message);
        });
    }
  }
};
</script>
